/**
 * Warn: For most functions, MutationObserver is included in the file assets/at-mutation-observer.js
 */

'use strict'

// console.log('atHeader');

const lang = document.querySelector('html').lang;

function initHeaderCustomization() {

  const observersConfig = [
    {
      selector: 'body.template-index header .header-logo .header-logo__image-container',
      requiresSource: false,
      callback: (element) => {
        const img = `<img src="https://m1y0db-vh.myshopify.com/cdn/shop/files/the-whatch-firm-logo-white.svg" class="header-logo_image--white">`;
        element.insertAdjacentHTML('beforeend', img);
        return true;
      }
    },
    {
      selector: 'header-menu.header-menu.mobile\\:hidden',
      requiresSource: false,
      callback: (element) => {
        setTimeout(() => {
          element.remove();
          return true;
        }, 500);
      }
    },
    {
      selector: 'header .menu-drawer.motion-reduce nav.menu-drawer__navigation',
      requiresSource: true,
      sourceSelector: 'div[data-source="first_mages"] div[data-testid="section-content"]',
      callback: (element, source) => {
        let content = source.outerHTML;

        content = content.replace(/id="[^"]*"/, '');

        element.insertAdjacentHTML('beforeend', `<div class="atInner"><div class="inner-container scroll-container">${content}</div></div>`);
        return true;
      }
    },
    {
      selector: 'header #link-all-collections .menu-drawer__inner-submenu',
      requiresSource: true,
      sourceSelector: 'div[data-source="collections"] .section-content-wrapper',
      callback: (element, source) => {
        let content = source.outerHTML;
        content = content.replace(/id="[^"]*"/, '');

        element.insertAdjacentHTML('beforeend', `<div style="z-index:10" class="atInner">${content}</div>`);
        return true;
      }
    },
    {
      selector: 'header #link-alle-kollektionen .menu-drawer__inner-submenu',
      requiresSource: true,
      sourceSelector: 'div[data-source="collections"] .section-content-wrapper',
      callback: (element, source) => {
        let content = source.outerHTML;
        content = content.replace(/id="[^"]*"/, '');

        element.insertAdjacentHTML('beforeend', `<div style="z-index:10" class="atInner">${content}</div>`);
        return true;
      }
    },
    {
      selector: 'header #link-katalog .menu-drawer__inner-submenu',
      requiresSource: true,
      sourceSelector: 'div#shopify-section-sections--26427550040410__section_LNCXxN .section-content-wrapper',
      callback: (element, source) => {
        let content = source.outerHTML;
        content = content.replace(/id="[^"]*"/, '');

        element.insertAdjacentHTML('beforeend', `<div style="z-index:10" class="atInner">${content}</div>`);
        return true;
      }
    },
    {
      selector: 'span.svg-wrapper.header-drawer-icon.header-drawer-icon--open',
      requiresSource: false,
      callback: (element) => {
        const closeIcon = `<svg class="at-icon close" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="-0.5 0 25 25" fill="none">
            <path d="M3 21.32L21 3.32001" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M3 3.32001L21 21.32" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>`;
        element.insertAdjacentHTML('beforeend', closeIcon);
        return true;
      }
    },
    {
      selector: '#header-group nav.menu-drawer__navigation.at-processed li.menu-drawer__list-item--flat > a',
      requiresSource: false,
      callback: (element) => {
        const chevronLeftIcon = `<span class="svg-wrapper icon-caret icon-caret--forward">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 5.5L7 9.5L3 5.5" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"
              stroke-linejoin="round"></path>
          </svg>
        </span>`;

        element.insertAdjacentHTML('beforeend', chevronLeftIcon);
        return true;
      }
    },
    {
      selector: 'html:not(.shopify-design-mode) [data-source="first_mages"] .image-block.front-image',
      requiresSource: false,
      callback: (element) => {
        const arcArrow = `<svg class="arc-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 213 212" height="212" width="213">
          <path fill="#F3F3F3"
            d="M9.9853 211.565C10.5711 212.151 11.5208 212.151 12.1066 211.565L21.6526 202.019C22.2384 201.433 22.2384 200.484 21.6526 199.898C21.0668 199.312 20.117 199.312 19.5312 199.898L11.046 208.383L2.56068 199.898C1.9749 199.312 1.02515 199.312 0.439362 199.898C-0.146425 200.484 -0.146425 201.433 0.439361 202.019L9.9853 211.565ZM199.985 89.1058C200.571 89.6916 201.521 89.6916 202.107 89.1058L211.653 79.5598C212.238 78.974 212.238 78.0243 211.653 77.4385C211.067 76.8527 210.117 76.8527 209.531 77.4385L201.046 85.9238L192.561 77.4385C191.975 76.8528 191.025 76.8528 190.439 77.4385C189.854 78.0243 189.854 78.9741 190.439 79.5599L199.985 89.1058ZM11.046 210.504H12.546C12.546 76.9163 59.9515 17.2322 106.419 5.30788C152.839 -6.60438 199.546 28.79 199.546 88.0451H201.046H202.546C202.546 27.1093 154.253 -10.0643 105.673 2.40203C57.1405 14.8563 9.546 76.4974 9.54596 210.504H11.046Z" />
        </svg>`;
        element.insertAdjacentHTML('beforeend', arcArrow);
        return true;
      }
    },
    {
      selector: 'html:not(.shopify-design-mode) .has-component-images.trade-in [data-source="first_mages"].image-block',
      requiresSource: false,
      callback: (element) => {
        const arcArrow = `<svg class="arc-arrow" width="264" height="269" viewBox="0 0 264 269" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.98524 268.191C10.571 268.776 11.5208 268.776 12.1066 268.191L21.6525 258.645C22.2383 258.059 22.2383 257.109 21.6525 256.523C21.0667 255.938 20.117 255.938 19.5312 256.523L11.0459 265.009L2.56062 256.523C1.97483 255.938 1.02509 255.938 0.439301 256.523C-0.146486 257.109 -0.146486 258.059 0.4393 258.645L9.98524 268.191ZM251.463 112.553C252.049 113.139 252.999 113.139 253.584 112.553L263.13 103.007C263.716 102.421 263.716 101.471 263.13 100.886C262.545 100.3 261.595 100.3 261.009 100.886L252.524 109.371L244.038 100.886C243.453 100.3 242.503 100.3 241.917 100.886C241.331 101.471 241.331 102.421 241.917 103.007L251.463 112.553ZM11.0459 267.13H12.5459C12.546 97.2913 72.8209 21.1716 132.158 5.94473C191.447 -9.27005 251.024 35.9549 251.024 111.492H252.524H254.024C254.024 34.2742 192.861 -12.73 131.412 3.03888C70.0099 18.7957 9.54596 96.8724 9.5459 267.13H11.0459Z"
            fill="#F3F3F3" />
        </svg>`;
        element.insertAdjacentHTML('beforeend', arcArrow);
        return true;
      }
    }
  ];

  const runLogic = () => {
    observersConfig.forEach((config) => {
      const elements = document.querySelectorAll(config.selector);

      elements.forEach((el) => {
        if (el.classList.contains('at-processed')) return;

        let success = false;

        if (config.requiresSource) {
          const source = document.querySelector(config.sourceSelector);
          if (source) {
            success = config.callback(el, source);
          }
        } else {
          success = config.callback(el);
        }

        if (success) {
          el.classList.add('at-processed');
        }
      });
    });
  };

  const observer = new MutationObserver((mutations) => {
    const hasAddedNodes = mutations.some(m => m.addedNodes.length > 0);
    if (hasAddedNodes) {
      runLogic();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  runLogic();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderCustomization);
} else {
  initHeaderCustomization();
}

function primaryNavMenu() {

  const primaryNav = document.querySelector('#header-group nav.menu-drawer__navigation.at-processed');
  if (!primaryNav) return;

  const openBtn = document.querySelector('#header-group .menu-drawer-container .header__icon--summary');
  if (openBtn) {
    openBtn.addEventListener('click', () => {
      primaryNav.classList.add('at-inner');
    });
  }

  const mainDetails = primaryNav.querySelectorAll('details.menu-drawer__menu-container');
  // console.log('mainDetails', mainDetails);
  const levelThreeDetails = primaryNav.querySelectorAll('details .menu-drawer__inner-submenu.at-processed');
  // console.log('levelThreeDetails', levelThreeDetails);
  const dd = primaryNav.querySelectorAll('li.menu-drawer__list-item.menu-drawer__list-item--flat>a');

  let hasClass = Array.from(mainDetails).some(el => el.classList.contains('menu-open'));

  mainDetails.forEach(detail => {
    const subMenuWrapper = detail.querySelector('.menu-drawer__inner-submenu');
    const subMenuItems = subMenuWrapper.querySelectorAll('ul.menu-drawer__menu.menu-drawer__menu--childlist li.menu-drawer__list-item');

    dd.forEach(d => {
      d.addEventListener('click', (e) => {
        e.preventDefault();
        detail.toggleAttribute('is-open');
      });
    });

    mainDetails.forEach(el => {
      detail.addEventListener('click', () => {
        subMenuWrapper.classList.remove('has-open');
        subMenuItems.forEach(item => {
          item.classList.remove('open', 'opacity');
        });

        if (detail !== el) {
          el.classList.remove('menu-open');
          el.removeAttribute('open');
        }

        setTimeout(() => {
          // console.log(detail.hasAttribute('open'));
          if (detail.hasAttribute('is-open')) {
            detail.setAttribute('open', '');
            detail.removeAttribute('is-open');
          } else {
            return;
          }
        }, 0);
      });
    });
  });
  // ---
  let levelThreeListItem = primaryNav.querySelectorAll('li.menu-drawer__list-item.menu-drawer__list-item--flat');
  // if (!levelThreeListItem.length) return;

  levelThreeListItem.forEach(item => {
    const levelThreeLink = item.querySelector('a');
    levelThreeLink.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      primaryNav.classList.remove('at-inner');

      levelThreeListItem = primaryNav.querySelectorAll('li.menu-drawer__list-item.menu-drawer__list-item--flat');

      setTimeout(() => {

        item.classList.toggle('open');
        setTimeout(() => {
          item.classList.toggle('opacity');
        }, 20);

        levelThreeListItem.forEach(element => {
          if (element !== item) {
            element.parentElement.classList.remove('open', 'opacity');
          }
        });

        hasClass = Array.from(levelThreeListItem).some(el => el.classList.contains('open'));
        if (hasClass) {
          item.parentElement.parentElement.classList.add('has-open');
        } else {
          item.parentElement.parentElement.classList.remove('has-open');
        }

        levelThreeListItem.forEach(els => {
          if (els !== item) {
            els.classList.remove('open', 'opacity');
          }
        });

      }, 30);
    });
  });
  // -----
  const details = document.querySelectorAll('#header-group nav.menu-drawer__navigation.at-processed .menu-drawer__menu-item.menu-drawer__menu-item--mainlist, #header-group details.menu-drawer-container button.close-button.menu-drawer__close-button');
  if (!details.length) return;
  details.forEach(detail => {
    detail.addEventListener('click', () => {
      primaryNav.classList.add('at-inner');
      const elements = primaryNav.querySelectorAll('.menu-drawer__menu--grandchildlist, .atInner');
      if (!elements.length) return;
      elements.forEach(element => {
        element.classList.remove('open', 'hidden', 'opacity');
      });
    })
  });

}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, primaryNavMenu)
);

function headerChange() {
  const header = document.querySelector('body.template-index #header-group');
  if (!header) return
  const openBtn = header.querySelector('.menu-drawer-container .header__icon--summary');
  const closeBtn = header.querySelector('button.button.close-button.menu-drawer__close-button');
  if (!openBtn || !closeBtn) return;

  openBtn.addEventListener('click', () => {
    header.classList.add('has-primary-bg');
    header.classList.remove('has-darck-bg');
  });

  closeBtn.addEventListener('click', () => {
    header.classList.remove('has-primary-bg');
  });

  const mainFirstChild = document.querySelector('body.template-index main#MainContent>:first-child')
  let rect = mainFirstChild ? mainFirstChild.getBoundingClientRect() : null;

  const headerComponent = document.querySelector('header-component#header-component')
  const headerHeight = headerComponent ? headerComponent.getBoundingClientRect().height : 0;

  const heroTextBlock = document.querySelector('.hero-video [data-id="hero-text-block"]');
  let rectHeroTextBlock = heroTextBlock ? heroTextBlock.getBoundingClientRect() : null;

  if (rect.bottom < headerHeight) header.classList.add('has-primary-bg');

  let previewScrollPosition = window.scrollY;
  window.addEventListener('scroll', () => {
    previewScrollPosition = window.scrollY;
    rect = mainFirstChild ? mainFirstChild.getBoundingClientRect() : null;
    rectHeroTextBlock = heroTextBlock ? heroTextBlock.getBoundingClientRect() : null;
    let currentScrollPosition = window.scrollY;
    // console.log(currentScrollPosition, rectHeroTextBlock.top, headerHeight);
    // console.log('test:', currentScrollPosition > rect.top + headerHeight)
    if (currentScrollPosition > rectHeroTextBlock.top + headerHeight) {
      header.classList.add('has-darck-bg');
    } else {
      header.classList.remove('has-darck-bg');
    }

    if (currentScrollPosition > mainFirstChild.offsetHeight - headerHeight) {
      header.classList.add('has-primary-bg');
      header.classList.remove('has-darck-bg');
    } else {
      header.classList.remove('has-primary-bg');
    }
    previewScrollPosition = currentScrollPosition;
  });

  const cardDrawner = header.querySelector('header-actions .cart-drawer');
  if (cardDrawner) {
    cardDrawner.addEventListener('click', () => {
      closeBtn.click();
      setTimeout(() => {      
        header.classList.remove('has-darck-bg');
        header.classList.add('has-primary-bg');
      }, 0);
    });
  }

}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, headerChange)
);

function atSearch() {
  const dialog = document.querySelector('dialog-component#search-modal dialog.search-modal__content.dialog-modal');
  const insertContainer = dialog.querySelector('form.predictive-search-form');
  if (!dialog || !insertContainer) return;

  const iconClose = `<span class="search-modal-close-icon"><svg class="at-icon close" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="-0.5 0 25 25" fill="none">
    <path d="M3 21.32L21 3.32001" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M3 3.32001L21 21.32" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg></span>`;

  insertContainer.insertAdjacentHTML('afterbegin', iconClose);
  const closeBtn = document.querySelector('.search-modal-close-icon');

  closeBtn.addEventListener('click', () => {
    if (!dialog.open) return;
    document.querySelector('html').removeAttribute('scroll-lock');
    document.body.style.width = '';
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo({ top: parseInt(scrollY) * -1, behavior: 'instant' });
    dialog.close();
  });

  const searchInput = document.querySelector('input#cmdk-input');
  if (!searchInput) return;

  const PLACEHOLDERS_CONFIG = {
    de: 'Ich suche ...',
    en: 'I am looking for ...',
    fr: 'Je recherche ...',
    // ***
  };

  // searchInput.placeholder = PLACEHOLDERS_CONFIG[lang] ?? PLACEHOLDERS_CONFIG['en'];
  const normalizedLang = lang.split('-')[0]; // for examle: 'en-EN' → 'en'
  searchInput.placeholder = PLACEHOLDERS_CONFIG[normalizedLang] ?? PLACEHOLDERS_CONFIG['en'];

}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, atSearch)
);

function filtersFixed() {
  const facets = document.querySelectorAll('.facets.facets--horizontal, .facets-toggle>.facets-toggle__wrapper');
  const resultList = document.querySelector('#ResultsList>div')
  if (!facets.length || !resultList) return;

  const header = document.querySelector('header #header-component');

  const headerHeight = header?.getBoundingClientRect().height - 2 ?? 0;
  const timeout = 500;

  let listRectTop = resultList?.getBoundingClientRect().top ?? null;
  let previewScrollPosition = window.scrollY;
  let currentScrollPosition = window.scrollY;
  facets.forEach(facet => {

    function fixed() {
      if (currentScrollPosition > listRectTop + 400) {
        facet.classList.add('active');
        facet.style.transform = `translateY(${headerHeight}px)`;
        setTimeout(() => {
        }, timeout);
      } else {
        facet.style.transform = 'translateY(0)';
        facet.classList.remove('active');
      }

      if (currentScrollPosition < -(listRectTop + 400)) {
        facet.style.transform = 'translateY(0)';
        facet.classList.remove('active');
      }
    }

    fixed();

    window.addEventListener('scroll', () => {
      listRectTop = resultList?.getBoundingClientRect().top ?? null;
      currentScrollPosition = window.scrollY;

      fixed();

      previewScrollPosition = currentScrollPosition;
    });

  });

}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, filtersFixed)
);

function upBtnInit() {
  const container = document.querySelector('footer.shopify-section-group-footer-group');
  if (!container) return;

  const HTML = `<span id="up-btn" style="position: fixed;">
    <svg class="icon chevron-top" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect width="24" height="24" fill="none" />
      <path d="M7 14.5L12 9.5L17 14.5" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </span>`;
  container.insertAdjacentHTML('afterend', HTML);

  const upBtn = document.querySelector('#up-btn');
  if (!upBtn) return;

  function upFunction() {
    upBtn.addEventListener('click', up, { passive: true });
    function up() {
      (function smoothscroll() {
        let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      })();
    }
  }
  upFunction();

  let previewScrollPosition = window.scrollY;
  window.addEventListener('scroll', () => {
    previewScrollPosition = window.scrollY;
    let currentScrollPosition = window.scrollY;

    if (previewScrollPosition > 400) {
      upBtn.classList.add('active');
    } else {
      upBtn.classList.remove('active');
    }
  }, { passive: true });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, upBtnInit)
);

// If needed
function linkFilterHrefAdd() {
  const containers = document.querySelectorAll('[data-link="true"]');
  containers.forEach(container => {
    const add = container.getAttribute('data-link-add');
    if (!add) return;
    const link = container.querySelector('a.group-block__link');
    if (!link) return;
    link.href = link.href + add;
  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, linkFilterHrefAdd)
);


(function () {
  const SELECTOR_CONTAINER = 'html:not(.shopify-design-mode) .atInner .recommended-products-wrapper';
  const SELECTOR_TITLE = '[data-role="recommended-products-title"]';
  const SELECTOR_ITEMS = '[data-product-id]';

  function processRecommendedProducts(container) {
    if (!container || container.classList.contains('inner-processed')) return;

    const title = container.querySelector(SELECTOR_TITLE);
    if (!title) return;

    const items = container.querySelectorAll(SELECTOR_ITEMS);
    if (!items.length) return;

    const allNull = Array.from(items).every(el => {
      const id = el.getAttribute('data-product-id');
      return !id || id === 'null' || id === 'undefined';
    });

    if (allNull) title.remove();

function horizontalScroll() {
  const scrollContainers = document.querySelectorAll('header #header-component .scroll-container, header #header-component .scroll-container .product-recommendations, .inner-container .scroll-container');

  scrollContainers.forEach(container => {
    // console.log('scrollContainers', container);
    container.addEventListener('wheel', function (e) {
      const { scrollLeft, scrollWidth, clientWidth } = container;
      const atStart = scrollLeft === 0;
      const atEnd = scrollLeft + clientWidth >= scrollWidth;

      const scrollingLeft = e.deltaY < 0;
      const scrollingRight = e.deltaY > 0;

      if ((atStart && scrollingLeft) || (atEnd && scrollingRight)) return;

      e.preventDefault();
      container.scrollLeft += e.deltaY;
    }, { passive: false });
  });
}
horizontalScroll();

    container.classList.add('inner-processed');
  }

  let debounceTimer = null;
  function debouncedProcess() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      document.querySelectorAll(SELECTOR_CONTAINER).forEach(processRecommendedProducts);
    }, 40);
  }

  ['DOMContentLoaded', 'shopify:section:load'].forEach(event => {
    document.addEventListener(event, () => {
      document.querySelectorAll(SELECTOR_CONTAINER).forEach(processRecommendedProducts);
    });
  });

  const root = document.querySelector('.atInner') || document.body;

  const observer = new MutationObserver(mutations => {
    if (mutations.some(m => m.addedNodes.length)) {
      debouncedProcess();
    }
  });

  observer.observe(root, {
    childList: true,
    subtree: true
  });
})();




